


















































import {Component, Prop, Vue} from 'vue-property-decorator'
import {State} from '@/views/diagnosis/Index.vue'
import {PortfolioRankingData, PortfolioRankingService} from '@/domain/PortfolioRanking'

@Component
export default class Ranking extends Vue {

  @Prop({type: Object, required: true})
  public state!: State

  private menu: RankingData[] = [
    {
      title: '直近一年の<span>リターンが高い順</span>のランキングです。',
      label: 'リターン',
      data: [],
      isActive: true,
    },
    {
      title: 'Wealth Wingのユーザーが<br /><span>選んでいる割合の多い順</span>のランキングです',
      label: '人気',
      data: [],
      isActive: false,
    },
    {
      title: '<span>ESGスコアの高い順</span>のランキングです',
      label: '社会貢献性',
      data: [],
      isActive: false,
    },
  ]

  public async created() {
    this.menu[0].data = (await PortfolioRankingService.getRanking('Profit')).portfolios
    this.menu[1].data = (await PortfolioRankingService.getRanking('Popularity')).portfolios
    this.menu[2].data = (await PortfolioRankingService.getRanking('Esg')).portfolios
  }

  get currentRankingTitle() {
    return this.menu.find((v) => v.isActive)?.title ?? ''
  }

  get currentRankingData() {
    return this.menu.find((v) => v.isActive)?.data ?? []
  }

  private next(code: string) {
    this.$emit('setState', {pms: code})
    this.$router.push({path: '/diagnosis/result', query: {...this.state}})
  }

  private propMenu(index: number) {
    this.menu.map((v) => v.isActive = false)
    this.menu[index].isActive = true
  }

  private printScore(scoreStr: string): string {
    return Number(Number(scoreStr).toFixed(1)).toString()
  }

  private printPlusOperator(scoreStr: string): string {
    return Number(scoreStr) > 0 ? '+' : ''
  }
}

interface RankingData {
  title: string,
  label: string,
  data: PortfolioRankingData[],
  isActive: boolean,
}
